// extracted by mini-css-extract-plugin
export var button = "_7v-7";
export var buttonRow = "_7v-6";
export var fadeIn = "_7v-1";
export var gradient = "_7v-0";
export var panel = "_7v-2";
export var panelIn = "_7v-3";
export var subtitle = "_7v-5";
export var title = "_7v-4";